module.exports = __webpack_public_path__ + "static/media/icon-delete.3c825b9b.svg";